import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import TextField from 'components/TextField';
import Form from 'components/Form';
import IconSelect from 'components/IconSelect';
import AgreementBlockSelect from 'components/AgreementBlockSelect';

import {
  AgreementBlock,
  TermEditForm_term$key,
} from '__generated__/TermEditForm_term.graphql';
import { useErrorHandler } from 'lib';

type FormFields = {
  name: string;
  icon: string | null;
  agreementBlock: AgreementBlock | null;
};

type Props = {
  term: TermEditForm_term$key;
};

const TermEditForm: FC<Props> = ({ term }) => {
  const errorHandler = useErrorHandler();

  const { id, ...initial } = useFragment(
    graphql`
      fragment TermEditForm_term on Term {
        id
        name
        icon
        agreementBlock
      }
    `,
    term
  );

  const [update, updating] = useMutation(graphql`
    mutation TermEditFormMutation($id: ID!, $input: UpdateTermInput!) {
      updateTerm(id: $id, input: $input) {
        ...EntitySidebar_entity
        ...TermEditForm_term
      }
    }
  `);

  const handleSubmit = useCallback(
    (input: FormFields) => {
      update({
        variables: { id, input },

        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormFields> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="termEditForm">
          <Section id="about" title="Apie">
            <Stack spacing={4}>
              <TextField autoFocus name="name" label="Pavadinimas" fullWidth />
              <IconSelect fullWidth name="icon" label="Ikona" />

              <AgreementBlockSelect
                name="agreementBlock"
                label="Įrašyti į sutartį prie"
              />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default TermEditForm;
